import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { userUrl } from "utils/route";

export const useUserRoute = (user) => {
  const currentUser = useSelector((state) => state.user.user);
  const [userProfileUrl, setUserProfileUrl] = useState("");

  useEffect(() => {
    if (!user) {
      return;
    }
    const url = userUrl(user, currentUser);
    setUserProfileUrl(url);
  }, [user, currentUser]);

  return {
    userProfileUrl,
  };
};
